import { Aligner } from '@alfa-bank/site-aligner';
import { Img } from '@alfa-bank/site-img';
import { Grid } from '@alfa-bank/site-grid-universal';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { TextContent } from '../../text-content';
import type { IDesktopDeps, TStepDesktop } from '../models';

import { StepDesktop as Component } from './step-desktop';

export const StepDesktop = createWidget<IDesktopDeps, TStepDesktop>({
    Aligner,
    Grid,
    Img,
    Text,
    TextContent,
})(Component);
